<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="primary white--text title">
                    Data Export
                </v-card-title>
                <v-card-text>
                    <equipment-selector v-model="equipment_name"></equipment-selector>
                    <date-range-selector v-model="range"></date-range-selector>
                </v-card-text>
                <v-card-actions>
                    <v-btn block class="secondary" @click="viewData">View Data</v-btn>
                    <v-btn block class="secondary" @click="downloadCSV">Download CSV</v-btn>
                </v-card-actions>
                <v-card-text>
                    <loading-progress-bar :loading="loading" v-if="loading"></loading-progress-bar>
                    <div style="overflow: scroll">
                    <table>
                        <tr>
                            <!-- header row -->
                            <td v-for="(m,k) in df" style="font-weight: bold">
                                {{k}}
                            </td>
                        </tr>
                        <tr v-for="(j,i) in df['timestamp']" v-if="i<end&&i>=start">
                            <td v-for="(m,k) in df">
                                {{m[i]}}
                            </td>
                        </tr>
                    </table>
                    </div>
                    <!-- Display Data as table -->
                </v-card-text>
                <v-pagination v-show="df['timestamp']"
                        v-model="pageNumber"
                        :length="tsLength"
                ></v-pagination>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import EquipmentSelector from '../components/EquipmentSelector'
  import DateRangeSelector from '../components/DateRangeSelector'
  import LoadingProgressBar from '../components/LoadingProgressBar'
  import {getTimeSeries} from '@/helper'
  import {exportCSVFromDicts} from "@/tocsv.js"

  export default {
    name: 'ViewData',
    components: { LoadingProgressBar, DateRangeSelector, EquipmentSelector },
    data () {
      return {
        equipment_name: null,
        range: null,
        loading: false,
          pageSize:50,
          pageNumber:1,

        df: {}
      }
    },
    computed: {
        start(){
            return (this.pageNumber-1) * this.pageSize;
        },
        end(){
            return this.start + this.pageSize;
        },
        tsLength(){
            if(!this.df['timestamp']){
                return 0;
            }
            return Math.ceil(this.df['timestamp'].length/this.pageSize)
        },
      facility_name () {
        return this.$store.state.pointsListStore.pointsList.facility_name
      },
      selectItems () {
      let output = []
      let id = 1
      // map format to v-treeview required format
      if (!this.$store.state.pointsListStore.pointsList) return []
      for (let i in this.$store.state.pointsListStore.pointsList.sensors){
        if (i===this.equipment_name) {
          let children = []
          id++
          for (let j in this.$store.state.pointsListStore.pointsList.sensors[i]) {
            children.push(
              this.$store.state.pointsListStore.pointsList.sensors[i][j]
              )
              id++
          }
          output.push(...children)
        }
      }
      return output
    }
    },
    methods: {
      async viewData () {
        this.pageNumber=1;
      this.loading=true
      if (!!this.equipment_name & !!this.facility_name & !!this.range){
        let df = await getTimeSeries(
          this.selectItems,
          this.equipment_name,
          this.facility_name,
          this.range,
          null,
          false, //ononly,
          null,
          true // clean data
        )
        this.df = df
      }
      this.loading=false
      },
      async downloadCSV () {
        await this.viewData()
        exportCSVFromDicts(this.df)
      }
    }
  }
</script>

<style scoped>
    table {
  border-collapse: collapse;
}

table, th, td {
  border: 1px solid black;
}

</style>
